<template>
	<div>
		<MainHeader />

		<b-container id="image-container" fluid class="p-3 p-md-4 p-lg-5" :style="{ backgroundImage: 'url('+address.img.src+')' }">
			<h2 class="text-white text-shadow mb-5">Domiciliation d'entreprise</h2>

			<h1 class="text-white text-shadow mb-5">{{ address.text }}</h1>

			<b-row cols="1" cols-sm="2">
				<b-col class="text-center mb-3 mb-md-0">
					<b-button v-b-modal.domiciliation-contact-modal variant="light" size="lg" class="btn-responsive">Être recontacté(e)</b-button>
				</b-col>

				<b-col class="text-center">
					<b-button @click="domiciliation" size="lg" class="btn-responsive">Se domicilier maintenant</b-button>
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="p-3 p-md-4 p-lg-5">
			<b-row class="mb-5">
				<b-col cols="12" md="8">
					<b-row class="mb-2">
						<b-col>
							<h3>Domiciliation {{ address.text }}</h3>
						</b-col>
					</b-row>

					<b-row>
						<b-col class="d-flex justify-content-start align-items-center">
							<img src="../../assets/images/icons/location.svg" alt="Icone de localisation" class="mr-2" width="30" height="30" />
							<p class="h4 text-black-50">{{ address.value }}</p>
						</b-col>
					</b-row>
				</b-col>

				<b-col cols="12" md="4">
					<b-row class="d-flex">
						<b-col>
							<p v-if="address.recurrence != null" class="h3"><b class="text-primary">{{ address.price }}{{ services.currency}}</b> {{ services.tva }} / {{ address.recurrence }}</p>

							<p v-else class="h3"><b class="text-primary">{{ address.price }}{{ services.currency}}</b> {{ services.tva }}</p>
						</b-col>

						<b-col>
							<b-button @click="domiciliation">Commencer</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="5" class="mb-5 mb-md-0">
					<b-embed
					:src="address.srcMap"
					allowfullscreen
					frameborder="0"
					style="border:0;"
					aria-hidden="false"
					tabindex="0"></b-embed>
				</b-col>

				<b-col cols="12" md="7">
					<p v-html="address.description" />
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="bg-light p-3 p-md-4 p-lg-5">
			<b-row>
				<b-col>
					<h4 class="h3 text-center">Gestion de votre courrier</h4>
				</b-col>
			</b-row>

			<b-row class="mb-5">
				<b-col>
					<h3 class="h4 text-center text-black-50">Domiciliation {{ address.text }}</h3>
				</b-col>
			</b-row>

			<b-row cols="1" cols-md="3" class="overflow-hidden">
				<b-col class="text-center" data-aos="fade-right">
					<img src="../../assets/images/icons/mail_options/available-courrier.svg" alt="Lettre rouge aux contours noirs" width="100" height="100" />
					<h5>Courier disponible en agence</h5>
					<p>Tri & stockage de vos lettres et colis</p>
				</b-col>

				<b-col class="text-center" data-aos="fade-up">
					<img src="../../assets/images/icons/mail_options/courrier-expedition.svg" alt="Lettre rouge aux contours noirs" width="100" height="100" />
					<h5>Réexpédition</h5>
					<p>Réexpédition de votre courrier</p>
				</b-col>

				<b-col class="text-center" data-aos="fade-left">
					<img src="../../assets/images/icons/mail_options/courrier-numerisation.svg" alt="Lettre rouge aux contours noirs" width="100" height="100" />
					<h5>Numérisation</h5>
					<p>Numérisation de votre courrier</p>
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="p-3 p-md-4 p-lg-5">
			<b-row class="mb-5">
				<b-col class="text-center">
					<h3>Questions fréquentes sur la domiciliation</h3>
				</b-col>
			</b-row>

			<b-row cols="1" cols-md="2">
				<b-col v-for="(question, index) in address.questions" :key="index">
					<h4 class="text-primary">{{ question.title }}</h4>
					<div v-html="question.answer" />
				</b-col>
			</b-row>
		</b-container>

		<Sidebar />

		<DomiciliationContactModal :address="address" />

		<MainFooter />
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	import MainHeader from '../../components/MainHeader.vue'
	import Sidebar from '../../components/Sidebar.vue'
	import DomiciliationContactModal from "../../components/domiciliation/DomiciliationContactModal.vue"
	import MainFooter from '../../components/MainFooter.vue'

	export default {
		components: {
			MainHeader,
			Sidebar,
			DomiciliationContactModal,
			MainFooter
		},
		methods: {
			domiciliation () {
				this.$router.push({ name: "domiciliation_address", params: { addressId: this.id + 1 } })
			}
		},
		computed: {
			id () {
				return this.$route.params.addressId - 1
			},
			address () {
				return this.services.domiciliation.addresses[this.id]
			},
			...mapState(['services'])
		}
	}
</script>
